import React from "react";
import Svg, { Path, Defs, G, Rect,ClipPath } from "react-native-svg";

export function ThunderNew({ width, height }) {
    return (
        <>
            <Svg width={width} height={height} viewBox="0 0 509 509" fill="none" xmlns="http://www.w3.org/2000/svg">
                <G clipPath="url(#clip0_525_2550)">
                    <Path d="M403.712 201.04H256.288L329.792 0L105.216 307.888H252.64L179.136 508.928L403.712 201.04Z" fill="#FFD83B" />
                </G>
                <Defs>
                    <ClipPath id="clip0_525_2550">
                        <Rect width="508.928" height="508.928" fill="white" />
                    </ClipPath>
                </Defs>
            </Svg>

        </>
    );
}
